import { createRoot } from "react-dom/client"

import AppContext from "./context/AppContext"

import reportWebVitals from "./reportWebVitals"
import App from "./App"

import "./index.scss"

const rootElement = document.getElementById("root")
const root = createRoot(rootElement)

root.render(
    <AppContext>
        <App />
    </AppContext>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
